module.exports = __webpack_public_path__ + "static/media/gameWaiterMemory.ceef87d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameWaiterMemory.png
// module id = 2515
// module chunks = 0